import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=d34b1864"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34b1864')) {
      api.createRecord('d34b1864', component.options)
    } else {
      api.reload('d34b1864', component.options)
    }
    module.hot.accept("./NavLink.vue?vue&type=template&id=d34b1864", function () {
      api.rerender('d34b1864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/NavLink.vue"
export default component.exports